import { useContext } from 'react';

import { ActiveWardrobeContext } from '../../../contexts/ActiveWardrobeContext';
import { WardrobesConfigsContext } from '../../../contexts/WardrobesConfigsContext';

export function useCheckWardrobe() {
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { wardrobesConfigs } = useContext(WardrobesConfigsContext);

  const { accessories } = wardrobesConfigs[activeWardrobe];

  const isAnyElementInWardrobe = Object.values(accessories)
    .map(accessoriesList => accessoriesList.length)
    .some(val => val > 0);

  return {
    hasAccessories: isAnyElementInWardrobe,
  };
}

export function useDedicatedAccessories() {
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { wardrobesConfigs, setWardrobesConfigs } = useContext(WardrobesConfigsContext);

  const updatedConfig = [...wardrobesConfigs];
  const zones = ['left', 'center', 'right'];

  const updateWardrobeConfig = (zone, data) => {
    updatedConfig[activeWardrobe].accessories[zone] = data;
  };

  const setDedicatedAccessories = dedicatedAccessories => {
    zones.forEach(zone => {
      const list = dedicatedAccessories.list[zone] || [];

      updateWardrobeConfig(zone, list);
    });
    setWardrobesConfigs(updatedConfig);
  };

  return setDedicatedAccessories;
}
